import { EmailCreationPopUp, isDirtyEmailCreationForm } from '../../../../Email'
import { MINIMIZED_MODAL_KEY } from '../../../../Modal'

import {
  APPLICANT_PROFILE_EMAILS_COMPOSE_FIELDS_PROPS,
  APPLICANT_PROFILE_EMAILS_COMPOSE_FORM_FIELDS_PROPS,
  APPLICANT_PROFILE_EMAILS_COMPOSE_RESIZE_CONFIG,
} from './ApplicantProfileEmailsComposePopUp.constants'

function ApplicantProfileEmailsComposePopUp({
  getContainerIsDirty,
  initialValues,
  onClose,
  onSubmit,
  onSuccess,
}) {
  return (
    <EmailCreationPopUp
      fieldsProps={APPLICANT_PROFILE_EMAILS_COMPOSE_FIELDS_PROPS}
      formFieldsProps={APPLICANT_PROFILE_EMAILS_COMPOSE_FORM_FIELDS_PROPS}
      getContainerIsDirty={getContainerIsDirty}
      getIsDirty={isDirtyEmailCreationForm}
      initialValues={initialValues}
      minimizedModalKey={MINIMIZED_MODAL_KEY.RENTAL_PORTAL_APPLICANT_EMAIL}
      resizeConfig={APPLICANT_PROFILE_EMAILS_COMPOSE_RESIZE_CONFIG}
      onClose={onClose}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
    />
  )
}

export default ApplicantProfileEmailsComposePopUp
